import * as React from "react";
import { uploadFile } from "../services/fileUpload";
import { Upload } from "../models/upload";

interface Props {
  upload?: Upload;
  name: string;
}
interface State {
  upload?: Upload;
  error?: string;
}

export class InlineUploader extends React.Component<Props, State> {
  private input: HTMLInputElement;

  public constructor(props: Props) {
    super(props);

    this.selectFile = this.selectFile.bind(this);
    this.beginUpload = this.beginUpload.bind(this);

    this.state = {
      upload: this.props.upload
    };

    this.input = document.createElement("input");
    this.input.type = "file";
    this.input.onchange = this.beginUpload;
  }

  public render() {
    let upload = this.state.upload;
    let progressBackground =
      !upload || upload.uploadComplete
        ? "inherit"
        : `linear-gradient(to right, lightblue, lightblue ${
            upload.uploadProgress
          }%, transparent  ${upload.uploadProgress + 5}%, transparent 100% )`;

    return [
      <div key="uploader" style={{ display: "flex", flexFlow: "row nowrap" }}>
        <button
          className="btn btn-white primary-color"
          style={{ flex: "1 1 auto" }}
          onClick={this.selectFile}
        >
          Select file
        </button>
        <div
          style={{
            flex: "1 1 100%",
            alignSelf: "center",
            marginLeft: "8px",
            background: progressBackground
          }}
        >
          {this.getFileName()}
        </div>
      </div>,
      this.state.error && (
        <span key="error" className="text-danger field-validation-error">
          {this.state.error}
        </span>
      ),
      <input
        key="input"
        type="hidden"
        name={this.props.name}
        value={this.state.upload ? this.state.upload.id : ""}
      />
    ];
  }

  private getFileName() {
    if (this.state.upload && this.state.upload.filename) {
      if (this.state.upload.href) {
        return (
          <a href={this.state.upload.href}>{this.state.upload.filename}</a>
        );
      } else {
        return this.state.upload.filename;
      }
    }
  }

  private selectFile(event: React.MouseEvent<HTMLButtonElement>) {
    event.preventDefault();
    this.input.click();
  }

  private beginUpload() {
    let file = this.input.files && this.input.files[0];

    if (file) {
      uploadFile(file).subscribe(
        upload => {
          this.setState({
            error: undefined,
            upload
          });
        },
        error =>
          this.setState({
            error
          })
      );
    }
  }
}
